export default __webpack_public_path__ + "static/project-slide-2-1248-765-8f9d2388c4eb5e7c8b83e15074fa01ae.jpg";